module.exports = __webpack_public_path__ + "img/ironia.f8d103fe.png";